/**
 * Animation Primitives — raw duration values and easing functions.
 */

export const durationValues = {
  fast: "100ms",
  base: "200ms",
  slow: "350ms",
} as const;

export const easing = {
  default: "ease-in-out",
  enter: "ease-out",
  exit: "ease-in",
} as const;
